import { ProjectWithRelations } from 'src/app/sdk-api';

export namespace ProjectState {
  export const key = 'project';

  export interface State {
    project: ProjectWithRelations;
  }

  export const initialState: State = {
    project: null,
  };
}
